import {Button} from '@material-ui/core';
import {createStyles, makeStyles} from '@material-ui/core/styles';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {useLocation} from 'react-router-dom';
import useLoadAttended from '../../../components/hooks/useLoadDetails';

const CollaboReadOnlyPage = ({history, location}: any) => {
  const styles = useStyles();
  return (
    <>
      <div className={styles.header}>
        <h2 className={styles.title}>
          {location.state.data.name}, {location.state.data.cwid}
        </h2>
        <div className={styles.button}>
          <Button
            title={i18n2._('Volver')}
            variant="contained"
            onClick={history.goBack}
            size="medium"
            color={'primary'}
          >
            {i18n2._('Volver')}
          </Button>
        </div>
      </div>
      <CollaboratorDetailsOfReadOnly />
    </>
  );
};

const CollaboratorDetailsOfReadOnly = () => {
  const location = useLocation();
  const loadAttended = useLoadAttended(
    'instanceJoinedWithCourse',
    location.state.key,
  );
  return (
    <IntegrityRoleGrid
      dataSource={loadAttended}
      id={['iD_Instance', 'iD_Course', 'employee_Nr']}
      allowIntegrity={false}
      allowActions={false}
      exportName="Collaborator-detail-export"
    >
      <Column caption={i18n2._('#Instancia')} dataField="iD_Instance" />
      <Column caption={i18n2._('#Curso')} dataField="iD_Course" />
      <Column caption={i18n2._('Nombre del empleado')} dataField="name" />
      <Column caption={i18n2._('CWID')} dataField="cwid" />
      <Column caption={i18n2._('Nombre del curso')} dataField="name_course" />
      <Column
        caption={i18n2._('Fecha de instancia')}
        dataField="instance_Date"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.instance_Date)}
      />
      <Column caption={i18n2._('Duración')} dataField="duration" />
      <Column caption={i18n2._('Calificacion')} dataField="score" />
      <Column caption={i18n2._('Intento')} dataField="attempt" />
      <Column caption={i18n2._('En tiempo')} dataField="onTime" />
      <Column caption={i18n2._('Presente')} dataField="present" />
      <Column caption={i18n2._('Aprobado')} dataField="approved" />
    </IntegrityRoleGrid>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    header: {
      position: 'relative',
    },
    title: {
      paddingLeft: 30,
      top: 0,
    },
    button: {
      position: 'absolute',
      paddingRight: 30,
      right: 0,
      top: 0,
      textAlign: 'right',
    },
  }),
);

export default CollaboReadOnlyPage;
